import { css, ThemeContext } from '@emotion/react';
import { useState, useContext } from 'react';
import { Trans } from 'react-i18next';

import { AppTheme } from 'theme';

import { BorderlessButton, Button, Flex } from 'components';
import { LobbyInvitation } from 'graphql/types';
import colors from 'lib/colors';

interface Props {
  invitation: LobbyInvitation;
  acceptInvitation: (id: string) => Promise<void>;
  rejectInvitation: (id: string) => Promise<void>;
}

const InvitationView = ({
  invitation,
  acceptInvitation,
  rejectInvitation,
}: Props) => {
  const theme = useContext(ThemeContext) as AppTheme;
  const IS_EDU = theme?.layout?.edu;
  const LOCIZE_SUFFIX_KEY = IS_EDU ? '.edu' : '';

  const [pending, setPending] = useState(false);

  const handleAccept = async () => {
    setPending(true);
    await acceptInvitation(invitation.id);
    setPending(false);
  };

  const handleReject = async () => {
    setPending(true);
    await rejectInvitation(invitation.id);
    setPending(false);
  };

  const inviter = invitation.inviter.name ?? invitation.inviter.email;

  return (
    <Flex flexDirection="column" alignItems="center" my={2}>
      <p
        css={css`
          font-size: 14px;
          color: ${colors.lobbyText};
        `}
      >
        <Trans i18nKey={`lobby.pendingInvitation${LOCIZE_SUFFIX_KEY}`}>
          Máte čekající pozvání do hry od {{ inviter }}!
        </Trans>
      </p>
      <Button
        labelT={{
          key: 'lobby.acceptInvitation',
          defaultValue: 'Přijmout pozvání',
        }}
        variant="warning"
        onClick={handleAccept}
        disabled={pending}
      />
      <BorderlessButton
        labelT={{ key: 'lobby.rejectInvitation', defaultValue: 'Odmítnout' }}
        disabled={pending}
        onClick={handleReject}
      />
    </Flex>
  );
};

export default InvitationView;
